import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import PinchZoom from 'vue-pinch-zoom';

import '@fortawesome/fontawesome-pro/css/all.css'
import '@fortawesome/fontawesome-pro/css/sharp-regular.css'

import HubModule from '@/modules/hub-module'
Vue.use(HubModule, { 
  apiURL: process.env.VUE_APP_API,
  withCredentials: true
})

var hub = Vue.prototype.$hub;
hub.onUserChange = userUpdated;

function userUpdated(user) {
  if(!user) {
    console.log("should log out.")
    hub.api.clearAll()
    // if((router.currentRoute.name || "").indexOf("auth.") < 0) {
    //   router.push({ name: 'auth.welcome' });
    // }
  }
}

hub.init();

//clear existing caches
hub.api.clearAll()

//Include filters globally
Vue.prototype.$filters = Vue.options.filters

Vue.config.productionTip = false

Vue.component('pinch-zoom', PinchZoom);

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
